module.exports = __webpack_public_path__ + "static/media/minoan_text_05.66bb26b6.jpg";